import { ILineFareInfo } from "@/domain/entities/lineInfo";
import { ParseError } from "@/repositories/shared/errors/parseError";
import { injectable } from "inversify";
import { err, ok, Result } from "neverthrow";
import { HttpLineFare, ILineFareParser } from "../lineInfoRepository.types";
import { BookIntervalCode } from "@/types";
import { LineFare } from "@/domain/entities/lineInfo/lineFare";

@injectable()
export class LineFareParser implements ILineFareParser {
  constructor() {}

  toDomain(data: HttpLineFare): Result<ILineFareInfo, ParseError> {
    try {
      const lineFareData: ILineFareInfo = {
        fareAmount: data.fareAmount,
        bookIntervalCode:
          data.bookIntervalCode === BookIntervalCode.MONTH
            ? BookIntervalCode.MONTH
            : BookIntervalCode.DAY,
        name: data.name,
        code: data.code,
        displayOrder: data.displayOrder,
      };
      const lineFare = new LineFare(lineFareData);
      return ok(lineFare);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
